import { createAction } from 'typesafe-actions';
import { LDFlagSet } from 'launchdarkly-js-client-sdk';

export const setFeatureFlags = createAction('featureFlags/SET_FEATURE_FLAGS')<LDFlagSet>();
